import React, { ImgHTMLAttributes } from 'react';
import styled from 'styled-components';

export type PictureProps = {
  src: string;
  alt: string;
  className?: string;
  loading?: ImgHTMLAttributes<HTMLImageElement>['loading'];
};

const Picture = ({ src, alt, className, loading }: PictureProps) => (
  <Wrapper className={className}>
    <img src={src} alt={alt} {...(loading ? { loading } : {})} />
  </Wrapper>
);

const Wrapper = styled.picture`
  img {
    width: 100%;
    max-width: 100%;
  }
`;

export default Picture;
